import { useContext, useEffect, useRef, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { useSearchParams } from 'react-router-dom';

import { useGetCsrDay7Query } from '@/app/services/excel';
import { useDefaultGridOptions } from '@/grid';
import { pivotDefaultColDef } from '@/grid/defaults';
import { PrimaryContext } from '@/services';

import { csrDay7SummaryColDefs } from './columnDefs';
import { TransformDataToSummary } from './ProcessSummaryData';
import { AccountSummary } from './types';

import './RecipSummary.css';

export const SummaryPage = () => {
  const defaultGridOptions = useDefaultGridOptions();
  const { themeMode } = useContext(PrimaryContext);
  const breedSummaryGridRef = useRef<AgGridReact>(null);

  const [params] = useSearchParams();
  const beginDate = params.get('beginDate');
  const endDate = params.get('endDate');
  const siteId = params.get('site');
  const accountId = params.get('account');

  const [breedSummaryData, setBreedSummaryData] = useState<AccountSummary[]>(
    [],
  );
  const [totals, setTotals] = useState({
    frozen: 0,
    implanted: 0,
    d65Frozen: 0,
    discarded: 0,
    total: 0,
  });

  const { data: csrDay7Data } = useGetCsrDay7Query(
    {
      beginDate,
      endDate,
      siteId,
      accountId,
    },
    { skip: !beginDate || !endDate },
  );

  useEffect(() => {
    if (csrDay7Data) {
      const { summaryData, totals: newTotals } =
        TransformDataToSummary(csrDay7Data);
      setBreedSummaryData(summaryData);
      setTotals(newTotals);
    }
  }, [csrDay7Data]);

  return (
    <div className="common-page">
      <div className="csrDay7__filters">
        <div className="filter-group">
          <div className="totals-summary">
            <div className="totals-row">
              <div className="total-item">
                <span className="total-label">Frozen:</span>
                <span className="total-value">{totals.frozen}</span>
              </div>
              <div className="total-item">
                <span className="total-label">Implanted:</span>
                <span className="total-value">{totals.implanted}</span>
              </div>
              <div className="total-item">
                <span className="total-label">D6.5-Frozen:</span>
                <span className="total-value">{totals.d65Frozen}</span>
              </div>
              <div className="total-item">
                <span className="total-label">Discarded:</span>
                <span className="total-value">{totals.discarded}</span>
              </div>
              <div className="total-item total-sum">
                <span className="total-label">Total:</span>
                <span className="total-value">{totals.total}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="csrDay7__summary-grid ag-theme-transova">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}`}
          defaultColDef={pivotDefaultColDef}
          columnDefs={csrDay7SummaryColDefs}
          rowData={breedSummaryData}
          ref={breedSummaryGridRef}
          animateRows={true}
          rowDragMultiRow={true}
          rowDragManaged={true}
        />
      </div>
    </div>
  );
};
